// Static site-wide constants (logo, hero images, translation labels, chat mock responses).
// Content data (cities, categories, activities, etc.) is now fetched from backend API.

export const SITE = {
  name: 'YUP',
  tagline: 'Your Utility Points',
  logo: 'https://static.wixstatic.com/media/1d54f5_eabd50b27cfa48ff9d5ee48f79bf4471~mv2.png/v1/crop/x_0,y_139,w_1250,h_859/fill/w_301,h_207,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/YUPlogo.png',
  heroBg: 'https://static.wixstatic.com/media/1d54f5_67a774bde570471eb30c0cba3d92aa06~mv2.jpg/v1/fill/w_1920,h_1080,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Progetto%20senza%20titolo%20(23)_edited.jpg',
  cityPageHeroBg: 'https://static.wixstatic.com/media/nsplsh_3589c942b0b54359b9e7f4ecf43baaff~mv2.jpg/v1/fill/w_1920,h_1080,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/nsplsh_3589c942b0b54359b9e7f4ecf43baaff~mv2.jpg',
  chatbotAvatar: 'https://static.wixstatic.com/media/11062b_e462f18661cb4b40a363db73acd3dc9f~mv2.jpeg/v1/fill/w_400,h_400,al_c,q_90,enc_avif,quality_auto/11062b_e462f18661cb4b40a363db73acd3dc9f~mv2.jpeg',
  newsletterImage: 'https://static.wixstatic.com/media/1d54f5_59c76789e45b4d979cecaa1fdb52f21a~mv2.png/v1/fill/w_600,h_500,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/external-file_edited.png',
  contactEmail: 'info@diamondinnovations.eu'
};

export const LANGUAGES = [
  { code: 'it', label: 'IT', flag: '🇮🇹', name: 'Italiano' },
  { code: 'en', label: 'EN', flag: '🇬🇧', name: 'English' },
  { code: 'de', label: 'DE', flag: '🇩🇪', name: 'Deutsch' },
  { code: 'fr', label: 'FR', flag: '🇫🇷', name: 'Français' },
  { code: 'es', label: 'ES', flag: '🇪🇸', name: 'Español' },
  { code: 'zh', label: '中', flag: '🇨🇳', name: '中文' },
  { code: 'ar', label: 'ع', flag: '🇸🇦', name: 'العربية', rtl: true }
];

export const T = {
  it: {
    welcome: 'BENVENUTO SU YUP', tagline: 'YOUR UTILITY POINTS', travelWithUs: 'VIAGGIA CON NOI...',
    signUpNow: 'Iscriviti ora', signUpDesc: "Resta aggiornato su luoghi, eventi e altro con la piattaforma di YUP.",
    emailPlaceholder: 'Inserisci qui la tua email', signUp: 'Iscriviti', formSent: 'Il modulo è stato inviato!',
    chatWithUs: 'Chatta con noi', soon: 'Presto disponibile', whatToSee: 'COSA VEDERE', experiences: 'YUP EXPERIENCES', events: 'EVENTI',
    theStory: 'LA STORIA', theMunicipality: 'IL COMUNE', emergency: 'EMERGENZE', municipality: 'COMUNE DI',
    backHome: 'Torna alla home', typeMessage: 'Scrivi un messaggio...', send: 'Invia',
    chatIntro: "Ciao! Sono l'assistente virtuale di YUP. Come posso aiutarti oggi? Chiedimi qualsiasi cosa sul Lago di Garda!",
    heroSubtitle: 'Ristoranti, attività, servizi ed emergenze — tutto quello che ti serve, sempre a portata di mano.',
    discover: 'Scopri',
    newsletterBadge: 'Newsletter YUP',
    newsletterTitle1: 'Non perdere', newsletterTitleHighlight: 'i luoghi migliori', newsletterTitle2: 'delle tue prossime destinazioni',
    newsletterDesc: 'Ricevi consigli di viaggio, luoghi segreti e le novità di YUP direttamente nella tua casella email. Niente spam, solo ispirazione.',
    newsletterSuccessExtra: 'Ci sentiamo presto.',
    sending: 'Invio...',
    trustLine: '100% Gratis · Niente Spam · Cancellati Quando Vuoi',
    sendError: 'Errore di invio, riprova.',
    featuredTitle: 'Esperienze da non perdere',
    featuredSubtitle: 'Selezionate a mano — luoghi ed esperienze imperdibili',
    citiesTitle: 'LE CITTÀ',
    // QR landing pages (/download, /desenzanoloft, /freeversion/*)
    availableOn: 'DISPONIBILE SU',
    discoverSite: 'SCOPRI IL SITO',
    clickHere: 'CLICCA QUI',
    loading: 'Caricamento...',
    pageNotFound: 'Pagina non trovata',
    qrNotFoundDesc: 'Il codice QR scansionato non corrisponde a nessuna landing attiva.',
    goToSite: 'VAI AL SITO',
    travelWithUs: 'VIAGGIA INSIEME A NOI...'
  },
  en: {
    welcome: 'WELCOME TO YUP', tagline: 'YOUR UTILITY POINTS', travelWithUs: 'TRAVEL WITH US...',
    signUpNow: 'Sign up now', signUpDesc: "Stay up to date on places, events and more with YUP's platform.",
    emailPlaceholder: 'Enter your email here', signUp: 'Sign up', formSent: 'The form has been sent!',
    chatWithUs: 'Chat with us', soon: 'Soon', whatToSee: 'WHAT TO SEE', experiences: 'YUP EXPERIENCES', events: 'EVENTS',
    theStory: 'THE STORY', theMunicipality: 'THE MUNICIPALITY', emergency: 'EMERGENCY', municipality: 'MUNICIPALITY OF',
    backHome: 'Back to home', typeMessage: 'Type a message...', send: 'Send',
    chatIntro: "Hi! I'm YUP's virtual assistant. How can I help you today? Ask me anything about Lake Garda!",
    heroSubtitle: 'Restaurants, activities, services and emergencies — everything you need, always at your fingertips.',
    discover: 'Discover',
    newsletterBadge: 'YUP Newsletter',
    newsletterTitle1: "Don't miss", newsletterTitleHighlight: 'the best places', newsletterTitle2: 'of your next destinations',
    newsletterDesc: 'Get travel tips, hidden gems and YUP updates straight to your inbox. No spam, just inspiration.',
    newsletterSuccessExtra: "We'll be in touch soon.",
    sending: 'Sending...',
    trustLine: '100% Free · No Spam · Cancel Anytime',
    sendError: 'Send error, please retry.',
    featuredTitle: 'Experiences not to be missed',
    featuredSubtitle: 'Hand-picked — unmissable places and experiences',
    citiesTitle: 'THE CITIES',
    // QR landing pages
    availableOn: 'AVAILABLE ON',
    discoverSite: 'DISCOVER THE SITE',
    clickHere: 'CLICK HERE',
    loading: 'Loading...',
    pageNotFound: 'Page not found',
    qrNotFoundDesc: 'The scanned QR code does not match any active landing page.',
    goToSite: 'GO TO SITE',
    travelWithUs: 'TRAVEL WITH US...'
  },
  de: {
    welcome: 'WILLKOMMEN BEI YUP', tagline: 'YOUR UTILITY POINTS', travelWithUs: 'REISE MIT UNS...',
    signUpNow: 'Jetzt anmelden', signUpDesc: 'Bleiben Sie mit der YUP-Plattform auf dem Laufenden.',
    emailPlaceholder: 'E-Mail hier eingeben', signUp: 'Anmelden', formSent: 'Das Formular wurde gesendet!',
    chatWithUs: 'Chatte mit uns', soon: 'Bald', whatToSee: 'SEHENSWERTES', experiences: 'YUP EXPERIENCES', events: 'VERANSTALTUNGEN',
    theStory: 'DIE GESCHICHTE', theMunicipality: 'DIE GEMEINDE', emergency: 'NOTFALL', municipality: 'GEMEINDE',
    backHome: 'Zurück zur Startseite', typeMessage: 'Nachricht schreiben...', send: 'Senden',
    chatIntro: 'Hallo! Ich bin der virtuelle Assistent von YUP. Wie kann ich helfen?',
    heroSubtitle: 'Restaurants, Aktivitäten, Dienstleistungen und Notfälle — alles was Sie brauchen, immer griffbereit.',
    discover: 'Entdecken',
    newsletterBadge: 'YUP Newsletter',
    newsletterTitle1: 'Verpassen Sie', newsletterTitleHighlight: 'die schönsten Orte', newsletterTitle2: 'Ihrer nächsten Reise',
    newsletterDesc: 'Reisetipps, geheime Orte und YUP-News direkt in Ihr Postfach. Kein Spam, nur Inspiration.',
    newsletterSuccessExtra: 'Wir melden uns bald.',
    sending: 'Sende...',
    trustLine: '100% Kostenlos · Kein Spam · Jederzeit abbestellbar',
    sendError: 'Sendefehler, bitte erneut versuchen.',
    featuredTitle: 'Nicht zu verpassende Erlebnisse',
    featuredSubtitle: 'Handverlesen — unvergessliche Orte und Erlebnisse',
    citiesTitle: 'DIE STÄDTE',
    // QR landing pages
    availableOn: 'VERFÜGBAR AUF',
    discoverSite: 'DIE WEBSITE ENTDECKEN',
    clickHere: 'HIER KLICKEN',
    loading: 'Wird geladen...',
    pageNotFound: 'Seite nicht gefunden',
    qrNotFoundDesc: 'Der gescannte QR-Code entspricht keiner aktiven Landingpage.',
    goToSite: 'ZUR WEBSITE',
    travelWithUs: 'REISE MIT UNS...'
  },
  fr: {
    welcome: 'BIENVENUE SUR YUP', tagline: 'YOUR UTILITY POINTS', travelWithUs: 'VOYAGEZ AVEC NOUS...',
    signUpNow: 'Inscrivez-vous', signUpDesc: "Restez au courant avec la plateforme YUP.",
    emailPlaceholder: 'Entrez votre email ici', signUp: "S'inscrire", formSent: 'Le formulaire a été envoyé !',
    chatWithUs: 'Discutez avec nous', soon: 'Bientôt', whatToSee: 'À VOIR', experiences: 'EXPÉRIENCES YUP', events: 'ÉVÉNEMENTS',
    theStory: "L'HISTOIRE", theMunicipality: 'LA MUNICIPALITÉ', emergency: 'URGENCE', municipality: 'MUNICIPALITÉ DE',
    backHome: "Retour à l'accueil", typeMessage: 'Écrire un message...', send: 'Envoyer',
    chatIntro: "Bonjour ! Je suis l'assistant virtuel de YUP.",
    heroSubtitle: 'Restaurants, activités, services et urgences — tout ce dont vous avez besoin, toujours à portée de main.',
    discover: 'Découvrir',
    newsletterBadge: 'Newsletter YUP',
    newsletterTitle1: 'Ne manquez', newsletterTitleHighlight: 'les plus beaux lieux', newsletterTitle2: 'de vos prochaines destinations',
    newsletterDesc: 'Recevez des conseils de voyage, des lieux secrets et les nouveautés de YUP directement dans votre boîte mail. Pas de spam, juste de l’inspiration.',
    newsletterSuccessExtra: 'À bientôt.',
    sending: 'Envoi...',
    trustLine: '100% Gratuit · Zéro Spam · Désabonnement Facile',
    sendError: "Erreur d'envoi, réessayez.",
    featuredTitle: 'Expériences à ne pas manquer',
    featuredSubtitle: 'Sélectionnées à la main — lieux et expériences incontournables',
    citiesTitle: 'LES VILLES'
  },
  es: {
    welcome: 'BIENVENIDO A YUP', tagline: 'YOUR UTILITY POINTS', travelWithUs: 'VIAJA CON NOSOTROS...',
    signUpNow: 'Regístrate ahora', signUpDesc: 'Mantente al día con la plataforma de YUP.',
    emailPlaceholder: 'Introduce tu email aquí', signUp: 'Registrarse', formSent: '¡El formulario ha sido enviado!',
    chatWithUs: 'Chatea con nosotros', soon: 'Próximamente', whatToSee: 'QUÉ VER', experiences: 'EXPERIENCIAS YUP', events: 'EVENTOS',
    theStory: 'LA HISTORIA', theMunicipality: 'EL AYUNTAMIENTO', emergency: 'EMERGENCIA', municipality: 'MUNICIPIO DE',
    backHome: 'Volver al inicio', typeMessage: 'Escribe un mensaje...', send: 'Enviar',
    chatIntro: '¡Hola! Soy el asistente virtual de YUP.',
    heroSubtitle: 'Restaurantes, actividades, servicios y emergencias — todo lo que necesitas, siempre a tu alcance.',
    discover: 'Descubrir',
    newsletterBadge: 'Newsletter YUP',
    newsletterTitle1: 'No te pierdas', newsletterTitleHighlight: 'los mejores lugares', newsletterTitle2: 'de tus próximos destinos',
    newsletterDesc: 'Recibe consejos de viaje, lugares secretos y novedades de YUP directamente en tu bandeja de entrada. Sin spam, solo inspiración.',
    newsletterSuccessExtra: 'Hablamos pronto.',
    sending: 'Enviando...',
    trustLine: '100% Gratis · Sin Spam · Cancela Cuando Quieras',
    sendError: 'Error de envío, inténtalo de nuevo.',
    featuredTitle: 'Experiencias imperdibles',
    featuredSubtitle: 'Seleccionadas a mano — lugares y experiencias que no te puedes perder',
    citiesTitle: 'LAS CIUDADES'
  },
  zh: {
    welcome: '欢迎来到 YUP', tagline: 'YOUR UTILITY POINTS', travelWithUs: '与我们一起旅行...',
    signUpNow: '立即注册', signUpDesc: '通过 YUP 平台了解最新的地点、活动等信息。',
    emailPlaceholder: '在此输入您的邮箱', signUp: '注册', formSent: '表单已发送！',
    chatWithUs: '与我们聊天', soon: '即将推出', whatToSee: '景点', experiences: 'YUP 体验', events: '活动',
    theStory: '故事', theMunicipality: '市政厅', emergency: '紧急情况', municipality: '市',
    backHome: '返回首页', typeMessage: '输入消息...', send: '发送',
    chatIntro: '你好!我是 YUP 的虚拟助手。今天我能帮你什么吗?',
    heroSubtitle: '餐厅、活动、服务和紧急情况 — 您需要的一切,触手可及。',
    discover: '探索',
    newsletterBadge: 'YUP 通讯',
    newsletterTitle1: '不要错过', newsletterTitleHighlight: '任何一刻', newsletterTitle2: '加尔达湖的',
    newsletterDesc: '获取独家活动、隐藏胜地和平台更新,直接发送到您的邮箱。无垃圾邮件,只有灵感。',
    newsletterSuccessExtra: '我们很快就会联系您。',
    sending: '发送中...',
    trustLine: '100% 免费 · 无垃圾邮件 · 随时取消',
    sendError: '发送错误,请重试。',
    featuredTitle: '不容错过的体验',
    featuredSubtitle: '精心挑选 — 不容错过的地点和体验',
    citiesTitle: '城市'
  },
  ar: {
    welcome: 'مرحبًا بك في YUP', tagline: 'YOUR UTILITY POINTS', travelWithUs: 'سافر معنا...',
    signUpNow: 'سجّل الآن', signUpDesc: 'ابقَ على اطلاع بالأماكن والفعاليات وأكثر عبر منصة YUP.',
    emailPlaceholder: 'أدخل بريدك الإلكتروني هنا', signUp: 'اشتراك', formSent: 'تم إرسال النموذج!',
    chatWithUs: 'تواصل معنا', soon: 'قريبًا', whatToSee: 'ما يمكن رؤيته', experiences: 'تجارب YUP', events: 'فعاليات',
    theStory: 'القصة', theMunicipality: 'البلدية', emergency: 'طوارئ', municipality: 'بلدية',
    backHome: 'العودة إلى الرئيسية', typeMessage: 'اكتب رسالة...', send: 'إرسال',
    chatIntro: 'مرحبًا! أنا المساعد الافتراضي لـ YUP. كيف يمكنني مساعدتك اليوم؟',
    heroSubtitle: 'مطاعم، أنشطة، خدمات وطوارئ — كل ما تحتاجه دائمًا في متناول يدك.',
    discover: 'اكتشف',
    newsletterBadge: 'نشرة YUP',
    newsletterTitle1: 'لا تفوّت', newsletterTitleHighlight: 'أي لحظة', newsletterTitle2: 'من بحيرة غاردا',
    newsletterDesc: 'احصل على فعاليات حصرية وأماكن سرية وتحديثات المنصة مباشرة إلى بريدك. لا رسائل مزعجة، فقط إلهام.',
    newsletterSuccessExtra: 'سنتواصل معك قريبًا.',
    sending: 'جاري الإرسال...',
    trustLine: '‏100٪ مجاني · بدون بريد مزعج · إلغاء في أي وقت',
    sendError: 'خطأ في الإرسال، حاول مرة أخرى.',
    featuredTitle: 'تجارب لا تفوَّت',
    featuredSubtitle: 'اختيارات يدوية — أماكن وتجارب لا تُنسى',
    citiesTitle: 'المدن'
  }
};
